import React from "react";
import { Link } from "gatsby";
import { DropDown, DropDownList, DropDownListItem } from "./dropdown";

function SteelBuildings({ isActive }) {  
	return(
		<DropDown className={`dropdown-menu ${isActive ? "active" : ""}`}>
				<DropDownList>
					<DropDownListItem><Link to="/steel-buildings/metal-carports">Carports </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings/metal-garages">Garages </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings/metal-barns">Barns </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings/rv-covers">RV Covers </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings/boat-carports">Boat Carports </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings/utility-carports">Utility Carports </Link></DropDownListItem>
					<DropDownListItem><Link to="/steel-buildings">All Steel Buildings</Link></DropDownListItem>
				</DropDownList>
		</DropDown>
	)
};

export default SteelBuildings;